import Cookies from "universal-cookie";
import $ from "jquery";

export const toggleSidebar = () => {
    document.body.className = (document.body.className === '') ? 'showSideBar' : '';
    document.getElementById('faded-bg').style.display = (document.body.className === '') ? 'none' : 'block';
}

let prevIndex = -1;

export const slideNav = (event, index) => {
    if (event.target.classList.contains('active')) {
        event.target.classList.remove('active');
        document.getElementsByClassName('sidebar-ddm')[index].style.display = 'none';
    } else {
        event.target.classList.add('active');
        document.getElementsByClassName('sidebar-ddm')[index].style.display = 'block';
    }

    if (prevIndex !== -1 && index !== prevIndex) {
        document.getElementById(prevIndex).classList.remove('active');
        document.getElementsByClassName('sidebar-ddm')[prevIndex].style.display = 'none';
    }
    prevIndex = index;
}

export const handleModalNoticeOverlay = (event) => {

    const $notice = $('.modal-notice-overlay');
    const noticeName = '_notice';
    const bodyClass = 'modal-notice-active';
    const noticeErrorClass = 'error';
    const $checkbox = $('#modal-notice-checkbox');
    const $ctaContainer = $('.modal-notice-cta-box');
    window.dataLayer = window.dataLayer || [];
    let goto;

    const cookies = new Cookies();
    let cookie = cookies.get(noticeName) || window.name;
  
    function getNoticeValue() {
      return localStorage.getItem(noticeName);
    }

    const noticeValue = getNoticeValue();

    if ((cookie && !noticeValue) || (cookie === 'viewed_all')) {
      localStorage.setItem(noticeName, cookie);
      $('body').addClass(noticeValue);
    }
  
    $('body').addClass(noticeValue);
  
    $('#site-wrapper, #site-sidebar').click(function(e) {
      const noticeValue = getNoticeValue();
  
      // is target a link?
      if (e.target.href) {
        goto = e.target.href
      } else if ( $(e.target).parents('a').length ) {
        goto = $(e.target).parents('a').attr('href')
      }
  
      if ($(e.target).hasClass('switch-lang')) {
        if (noticeValue) {
          if (noticeValue === 'viewed') {
            localStorage.setItem(noticeName, 'false');
          } else if (noticeValue === 'false') {
            localStorage.setItem(noticeName, 'viewed');
          }
        }
        return
      }
  
      if (noticeValue === 'viewed' || noticeValue === 'viewed_all') {
        return;
      }
  
      e.preventDefault();
      if (noticeValue !== 'viewed' && noticeValue !== 'viewed_all') {
        $('body').addClass(bodyClass);
        if (window.dataLayer) {
          window.dataLayer.push({'event': 'notice_modalPopupOpened'});
        }
      } 
  
      if (noticeValue === 'viewed' || noticeValue === 'viewed_all') {
        $('body').removeClass(bodyClass);
      }
  
      $notice.click(function(e) {
        if (!$(e.target).hasClass('void') && !$(e.target).hasClass('ok')) {
          $ctaContainer.addClass(noticeErrorClass);
          $('.modal-notice-cta').not(':animated').fadeOut().fadeIn();
    
          if ($(e.target).closest(".modal-notice-main").length) {
            if (window.dataLayer) {
              window.dataLayer.push({'event': 'notice_modalPopupOKUncheckedClick'});
            }
          } else {
            if (window.dataLayer) {
              window.dataLayer.push({'event': 'notice_modalPopupOutsideClick'});
            }
          }
        }
      });
    
      $ctaContainer.click(function(e) {
        $($checkbox).prop('checked', true);
        if (window.dataLayer) {
          window.dataLayer.push({'event': 'notice_modalPopupOKCheckedClick'});
        }
        setTimeout(function() {
          $('body').removeClass(bodyClass);
          $ctaContainer.removeClass(noticeErrorClass);
          
          if (!noticeValue || noticeValue !== 'viewed' || noticeValue !== 'viewed_all') {
            if (noticeValue === 'false') {
              localStorage.setItem(noticeName, 'viewed_all');
            } else {
              localStorage.setItem(noticeName, 'viewed');
            }
          }
          
          $('body').addClass(noticeValue);
          if (goto) {
            window.location = goto
          }
        }, 300);
      });
    });
}